<template>
  <p style="display: none"></p>
</template>
<script>
export default {
  beforeMount() {
    this.$store.dispatch('authStudent/logout');
  },
};
</script>
